import { TAB_DEFINE } from './constants';

const mapTabKeyToName = (tabKey) => {
  return TAB_DEFINE[tabKey];
};

export { mapTabKeyToName };
